import React from 'react';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { Badge } from './Badge.esm.js';

const AlertBadge = ({ count, dataMetrics, dataTestId }) => {
    return (React.createElement(Badge, { dataMetrics: dataMetrics, dataTestId: dataTestId || `badge-${testIdGen(count.toString())}`, appearance: "red" }, count));
};

export { AlertBadge };
//# sourceMappingURL=AlertBadge.esm.js.map
